module.exports = __webpack_public_path__ + "img/Best of Chile Rot.b618d15a.jpg";